import { em, percent } from "csx";
import * as React from "react";
import { style } from "typestyle";
import { classNames } from "./utils.js";
const viewStyle = style({
    height: percent(100),
    display: "flex",
    flexFlow: "column nowrap",
    backgroundColor: "var(--color-background)",
    color: "var(--color-foreground)",
    position: "relative"
});
export const View = (props) => (React.createElement("div", { className: classNames(viewStyle, props.className) }, props.children));
const viewHeaderStyle = style({
    flex: "0 0 auto",
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
});
export const ViewHeader = (props) => (React.createElement("div", { className: classNames(viewHeaderStyle, props.className) }, props.children));
const viewHeaderItemStyle = style({
    flex: "0 1 auto",
    alignSelf: "center"
});
const viewHeaderItemFillStyle = style({
    flex: 1,
    alignSelf: "center"
});
export const ViewHeaderItem = ({ children, className, fill = false }) => (React.createElement("div", { className: classNames(fill ? viewHeaderItemFillStyle : viewHeaderItemStyle, className) }, children));
const viewTitleStyle = style({
    padding: "0 1rem",
    fontSize: em(1.5),
    fontWeight: 500
});
export const ViewTitle = ({ children }) => (React.createElement("div", { className: viewTitleStyle }, children));
const viewDescriptionStyle = style({
    padding: "0 1rem",
    fontSize: em(1),
    fontWeight: 300
});
export const ViewDescription = ({ children }) => (React.createElement("div", { className: viewDescriptionStyle }, children));
const viewActionsStyle = style({
    paddingRight: em(1.5),
    display: "flex",
    flexFlow: "row wrap"
});
export const ViewActions = ({ children }) => (React.createElement("div", { className: viewActionsStyle }, children));
const viewContentStyle = style({
    flex: 1,
    overflowY: "auto"
});
export const ViewContent = (props) => (React.createElement("div", { className: classNames(viewContentStyle, props.className) }, props.children));
const viewFooterStyle = style({
    flex: "0 0 min-content",
    display: "flex",
    flexFlow: "row nowrap"
});
export const ViewFooter = (props) => (React.createElement("div", { className: classNames(viewFooterStyle, props.className) }, props.children));
const viewFooterItemStyle = style({
    flex: "0 1 auto"
});
const viewFooterItemFillStyle = style({
    flex: 1
});
export const ViewFooterItem = ({ children, className, fill = false }) => (React.createElement("div", { className: classNames(fill ? viewFooterItemFillStyle : viewFooterItemStyle, className) }, children));
//# sourceMappingURL=view.js.map